const setLocalStorage = ({ name, value }: { name: string; value: string }) =>
  localStorage.setItem(name, value);

const getLocalStorage = (name: string) => localStorage.getItem(name);

const removeLocalStorage = (name: string) => localStorage.removeItem(name);

const clearLocalStorage = () => localStorage.clear();

export const localStorageService = {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  clearLocalStorage,
};
